import { connect, MapStateToProps } from 'react-redux';
import { Props } from './DefaultPageContent';
import { AppState } from '../../../../types/store';
import { getInitialOffset } from '../../../../selectors/stream';
import { getCurrentFeedType } from '../../../../selectors/page';

export type StateProps = Pick<Props, 'initialOffset' | 'feedType'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  initialOffset: getInitialOffset(state),
  feedType: getCurrentFeedType(state),
});

export default connect(mapStateToProps);
